import { useApiLlmStatus } from '@repo/api-codegen';
import { useSessionStorageBooleanState } from '@repo/common/hooks/useSessionStorageBooleanState';
import { Banner } from '@repo/foundations';
import { memo } from 'react';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import { useFeatureFlags } from '../../utils/featureFlags/useFeatureFlags';

function InternalLlmStatusBannerController() {
	const { disableAiAssistantStatusBanner } = useFeatureFlags();
	const [isDismissed, { setTrue: dismissBanner }] =
		useSessionStorageBooleanState('llmStatusBannerDismissed', false);

	const { data: llmStatus, isLoading, error } = useApiLlmStatus({});

	if (disableAiAssistantStatusBanner || isDismissed || isLoading || error) {
		return null;
	}

	// Only show banner if there are issues
	if (llmStatus && !llmStatus.is_healthy) {
		return (
			<Banner
				message={
					<>
						{llmStatus.message}{' '}
						<a
							href={llmStatus.status_page_url}
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: 'inherit' }}
						>
							View status
						</a>
					</>
				}
				tone="info"
				onDismiss={dismissBanner}
			/>
		);
	}

	return null;
}

function nullRenderer() {
	return <div style={{ display: 'none' }} />;
}

export const LlmStatusBannerController = memo(() => (
	<ErrorBoundary fallback={nullRenderer}>
		<InternalLlmStatusBannerController />
	</ErrorBoundary>
));
